import Component from '../core/Component'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'
import anime from 'animejs'

export const STATES = {
    ACTIVE: 'is-active',
    READY: 'is-ready'
}

export default class PopupNavOpener extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            opener: null,
            line1: null,
            line2: null,
            line3: null,
            line4: null,
            titleOpen: null,
            titleClose: null,
            more: null,
            langSwitch: null,
        }
    }

    prepare() {
        this.ref.opener.addEventListener('click', this.handleClick)
        EventBus.on(EVENTS.POPUPNAV_CLOSESTART, this.handlePopupNavCloseStart)
        EventBus.on(EVENTS.POPUPNAV_OPENSTART, this.handlePopupNavOpenStart)
        this.element.classList.add(STATES.READY)
    }

    destroy() {
        EventBus.off(EVENTS.POPUPNAV_CLOSESTART, this.handlePopupNavCloseStart)
        EventBus.off(EVENTS.POPUPNAV_OPENSTART, this.handlePopupNavOpenStart)
    }

    handleClick = (event) => {
        event.preventDefault()

        const id = event.currentTarget.hash.replace('#', '')

        const nav = Component.getFromElement(id)
        if (!nav) {
            return
        }

        nav.toggle()
    }

    handlePopupNavCloseStart = () => {
        this.element.classList.remove(STATES.ACTIVE)
        this.deactivate()
    }

    handlePopupNavOpenStart = () => {
        this.element.classList.add(STATES.ACTIVE)
        this.activate()
    }

    activate() {
        this.ref.langSwitch.style.pointerEvents = 'all'
        const animation = this.getAnimation()
        animation.reverse()
        animation.play()
    }

    deactivate() {
        this.ref.langSwitch.style.pointerEvents = 'none'
        const animation = this.getAnimation()
        animation.reverse()
        animation.play()
    }

    getAnimation() {
        if (this.animation) {
            return this.animation
        }

        this.animation = anime.timeline({
            easing: 'easeInOutQuad',
            duration: 300,
        })

        this.animation
            .add({
                targets: this.ref.line1,
                translateX: ['0', '100%'],
            })
            .add(
                {
                    targets: this.ref.line4,
                    translateX: ['0', '-100%'],
                },
                '-=100'
            )
            .add({
                targets: this.ref.line2,
                transformOrigin: ['50% 50%', '50% 50%'],
                rotate: [0, 30],
                duration: 400,
            })
            .add(
                {
                    targets: this.ref.line3,
                    transformOrigin: ['50% 50%', '50% 50%'],
                    rotate: [0, -30],
                    duration: 400,
                },
                '-=400'
            )
            .add(
                {
                    targets: this.ref.titleOpen,
                    translateY: ['0', '100%'],
                    width: [this.ref.titleOpen.offsetWidth, this.ref.titleClose.offsetWidth],
                    duration: 400,
                },
                '-=800'
            )
            .add(
                {
                    targets: this.ref.titleClose,
                    translateY: ['-100%', '0%'],
                    duration: 400,
                },
                '-=600'
            )
            .add(
                {
                    targets: this.ref.more,
                    translateX: ['0', '-150%'],
                    duration: 450,
                },
                '-=800'
            )
            .add(
                {
                    targets: this.ref.langSwitch,
                    opacity: [0, 1],
                    duration: 300,
                },
                '-=400'
            )

        this.animation.reverse()
        return this.animation
    }
}
